import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 17px; /* stylelint-disable-line scales/space */
`
